module.exports = __webpack_public_path__ + "static/media/reportCxcCompany.7dea3489.svg";